import { useMediaQuery, useTheme } from '@mui/material';
import TaskCreateModalDesktop from './TaskCreateModalDesktop';
import {
  Binding,
  CreateTaskInput,
  InvoiceStatus,
  TaskSettlementStatus,
} from '@admiin-com/ds-graphql';
import { useFormContext, useFormState } from 'react-hook-form';
import React, { useEffect } from 'react';
import { PageType } from './type';
import TaskCreateModalMobile from './TaskCreateModalMobile';
import { TaskCreateModalProps } from '.';
import { useTaskCreationContext } from '../../features/providers/TaskCreationProvider/useTaskCreationContext';
import { useModal } from '../../features/components/ModalManager/ModalContext';
import { useTranslation } from 'react-i18next';

function TaskCreatModal({
  open,
  onClose,
  task,
  taskType,
  onSuccess,
}: TaskCreateModalProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { openModal } = useModal();
  const { t } = useTranslation();
  const context = useTaskCreationContext();

  const { setValue } = useFormContext();

  const [createdTask, setCreatedTask] = React.useState<CreateTaskInput | null>(
    null
  );
  const [binding, setBinding] = React.useState<Binding | null>(null);

  const { taskDirection, resetForm, isTaxBinding } = context ?? {};
  const [page, setPage] = React.useState<PageType>('INVOICE&QUOTES');

  const { isDirty } = useFormState();

  useEffect(() => {
    switch (taskType) {
      case 'invoice':
        setPage('INVOICE&QUOTES');
        break;
      case 'quote':
        setPage('INVOICE&QUOTES');
        setValue('invoiceStatus', InvoiceStatus.QUOTE);
        break;
      case 'bills':
        setPage('PAY_BILL');
        break;
      case 'eSignature':
        setPage('E_SIGNATURE');
        break;
      case 'forwardBills':
        setPage('PAY_BILL');
        break;
      case 'document':
        setPage('E_SIGNATURE');
        break;
      case 'tax':
        setPage('E_SIGNATURE');
        setValue('settlementStatus', TaskSettlementStatus.PAYABLE);
        // TODO: Future task input true
        // TODO: 75556 billercode ATO selected as "From" for payment
        break;
      default:
        break;
    }
  }, [taskType, setPage, setValue]);

  const onSignatureCreated = (
    task: CreateTaskInput,
    options?: { binding?: Binding | null }
  ) => {
    setPage('FINISH');
    setCreatedTask(task);
    setBinding(options?.binding ?? null);
    resetForm();
    onSuccess?.(task);
  };

  // React.useEffect(() => {
  //   resetForm();
  // }, [page]);

  const handleClose = () => {
    if (isDirty) {
      openModal('confirmDialog', {
        title: t('closeConfirmationTitle', { ns: 'taskbox' }),
        message: t('closeConfirmationSubTitle', { ns: 'taskbox' }),
        onOK: onClose,
      });
    } else {
      onClose();
    }
  };

  const newProps = {
    open,
    onClose: handleClose,
    page,
    setPage,
    isEditing: !!task,
    onSignatureCreated,
    taskDirection,
    createdTask,
    binding,
    taskType,
    isBinding: isTaxBinding,
    taskProps: task,
  };

  return isMobile ? (
    <TaskCreateModalMobile {...newProps} />
  ) : (
    <TaskCreateModalDesktop {...newProps} />
  );
}
export default TaskCreatModal;
